const DEFAULT_GO_AWAY = 3000;

class KToast {
  constructor(toasted) {
    this.toasted = toasted;
    this.icons = {
      success: '<i class="fas fa-check-circle" aria-hidden="true"></i>',
      warning: '<i class="fas fa-exclamation-triangle" aria-hidden="true"></i>',
      error: '<i class="fas fa-exclamation-circle" aria-hidden="true"></i>',
      info: '<i class="fas fa-info-circle" aria-hidden="true"></i>',
    };
  }

  _formatMessage(message, type) {
    return `${this.icons[type] || ''}<span class="toast-text">${message}</span>`;
  }

  showToast(type, message, options = {}) {
    if (options.disableGoAway) {
      this.toasted.show(this._formatMessage(message, type), options);
      return;
    }

    const goAway = options.goAway || DEFAULT_GO_AWAY;
    this.toasted.show(this._formatMessage(message, type), options).goAway(goAway);
  }

  success(message, options = {}) {
    this.showToast('success', message, options);
  }

  warning(message, options = {}) {
    this.showToast('warning', message, options);
  }

  error(message, options = {}) {
    this.showToast('error', message, options);
  }

  info(message, options = {}) {
    this.showToast('info', message, options);
  }
}

export default {
  install(app) {
    const ktoast = new KToast(app.config.globalProperties.$toasted);
    app.config.globalProperties.$ktoast = ktoast;
  },
};
